import './module.style.css'

const Loader = () => {

    return (
        <div className='h-[0vh] mx-auto flex justify-center py-[70px]'>
            <span className="loader inline-block"></span>
        </div>
    )
}
export default Loader;